import {Component, effect, EventEmitter, inject, OnInit, Output} from '@angular/core';
import {LanguageService} from '../../core/language.service';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {components} from '../../configs/config';
import {IonButton, IonIcon, IonImg, IonInput, IonLabel} from '@ionic/angular/standalone';
import {AuthService} from '../auth.service';
import {Router, RouterLink} from '@angular/router';
import {AlertService} from '../../core/alert.service';
import { GoogleAuthProvider } from 'firebase/auth'
import {Auth, signInWithEmailAndPassword, signInWithPopup} from '@angular/fire/auth';
import {LogoComponent} from '../../common/header/logo/logo.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../../pages/contact/contact-form/contact-form.component.scss', './login.component.scss'],
  imports: [
    FormsModule,
    IonButton,
    IonInput,
    IonLabel,
    ReactiveFormsModule,
    IonIcon,
    IonImg,
    LogoComponent,
    RouterLink
  ]
})
export class LoginComponent  implements OnInit {

  formTextContent: any;
  languageService: LanguageService = inject(LanguageService);
  loginForm = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    type: new FormControl('user', [Validators.required]),
  });
  forgotPw = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl(''),
    confirmPassword: new FormControl(''),
  });
  @Output() isForgotPassword = new EventEmitter<boolean>();
  authService: AuthService = inject(AuthService);
  isSuccess: boolean = false;
  private auth = inject(Auth);
  constructor() {
    effect(async () => {
      if (this.languageService.lang()) {
        this.formTextContent = await this.languageService.loadContent(components.forms);
      }
    });
  }

  ngOnInit() {}
  router: Router = inject(Router);
  alertService: AlertService = inject(AlertService);
  forgotPassword: boolean = false;
  async loginUser() {
    try {
      const data: any = this.loginForm.value;
      await signInWithEmailAndPassword(this.auth, data.email, data.password);
      this.isSuccess = true;
      setTimeout(() => {
        this.router.navigate(['/']);
      }, 2500);
    } catch (e: any) {
      await this.alertService.showToast('danger', e.message);
    }
  }
  async loginWithGoogle() {
    const provider = new GoogleAuthProvider();
    signInWithPopup(this.auth, provider)
      .then(async (result) => {
        const user: any = result.user;
        const userExists: any = await this.authService.findUser(user.email);
        console.log(user);
        if (userExists.result === 1) {
          await this.router.navigate(['/user/register'], { queryParams: { email: user.email, displayName: user.displayName, uid: user.uid } });
        } else {
          await this.router.navigate(['/'])
        }
        console.log(userExists);
      })
      .catch(error => {
        console.log(error);});
  }
  changeForgotPassword() {
    this.forgotPassword = !this.forgotPassword;
    this.isForgotPassword.emit(this.forgotPassword);
  }

  async sendPasswordResetEmail() {
    await this.alertService.showLoader('Sending email...');
    try {
      await this.authService.sedPasswordResetEmail(this.forgotPw.value.email);
      this.alertService.dismissLoader();
      this.isSuccess = true;
    } catch (error: any) {
      await this.alertService.showToast('danger', error);
      this.alertService.dismissLoader();
      console.log(error);
    }
  }

}
